import React, { useState, useRef, useEffect } from 'react';
import CardPorServiciosPage from '../../Pages/CardPorServicios/CardPorServicios';
import logo from '../../Imgs/Logo.png';
import './NavBar.scss';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false); // menú hamburguesa (mobile)
  const [showServicios, setShowServicios] = useState(false); // panel de servicios
  const closeTimeout = useRef(null);

  const openServicios = () => {
    clearTimeout(closeTimeout.current);
    setShowServicios(true);
  };

  const closeServiciosDelayed = () => {
    closeTimeout.current = setTimeout(() => setShowServicios(false), 200);
  };

  const toggleServicios = () => setShowServicios((prev) => !prev);

  // Cerrar con Escape y limpiar el timeout al desmontar
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setShowServicios(false);
        setMenuOpen(false);
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      clearTimeout(closeTimeout.current);
    };
  }, []);

  return (
    <>
      <header className="navbar">
        <div className="navbar__inner">
          <a href="/" className="navbar__brand">
            <img src={logo} alt="Potrero Digital" className="navbar__logo" />
          </a>

          <button
            type="button"
            className={`navbar__toggle ${menuOpen ? 'is-open' : ''}`}
            aria-label="Abrir menú"
            aria-expanded={menuOpen}
            aria-controls="navbar-menu"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="navbar__toggle-bar" />
            <span className="navbar__toggle-bar" />
            <span className="navbar__toggle-bar" />
          </button>

          <nav
            id="navbar-menu"
            className={`navbar__menu ${menuOpen ? 'is-open' : ''}`}
          >
            <ul className="navbar__list">
              <li
                className="navbar__item"
                onMouseEnter={openServicios}
                onMouseLeave={closeServiciosDelayed}
              >
                <button
                  type="button"
                  className={`navbar__link ${showServicios ? 'is-active' : ''}`}
                  aria-expanded={showServicios}
                  aria-controls="servicios-panel"
                  onClick={toggleServicios}
                >
                  Servicios
                  <span
                    className={`navbar__chevron ${showServicios ? 'is-open' : ''}`}
                    aria-hidden="true"
                  >
                    ▾
                  </span>
                </button>
              </li>

         {/*    <li className="navbar__item">
                <a className="navbar__link" href="#about">
                  Perfil
                </a>
              </li>

              <li className="navbar__item">
                <a className="navbar__link" href="#contact">
                  Contacto
                </a>
              </li>*/} 
            </ul>
          </nav>
        </div>
      </header>

      <div
        id="servicios-panel"
        className={`servicios-panel ${showServicios ? 'is-open' : ''}`}
        onMouseEnter={openServicios}
        onMouseLeave={closeServiciosDelayed}
      >
        <div className="servicios-panel__inner">
          <CardPorServiciosPage />
        </div>
      </div>
    </>
  );
};

export default NavBar;